<core-badge
    variant="standard"
    size="condensed"
    color="blue"
    label="{{label}}"
    value="0"
    limit="0"
    iconclass="icon-16-profile-mono">
</core-badge>
